import { getters } from "@shared/template/StoreTemplates/FilterStoreTemplate"
import { toApiDate } from "@hub/tenant/src/helpers/accessPeriod.helper"

export default {
  ...getters,
  currentStep: (state) => state.currentStep,
  uuid: (state) => state.uuid,
  isEditing: (state) => state.isEditing,
  steps: (state) => state.steps,
  namedSteps: (state) => state.stepsNamedRoutes,
  tenant: (state) => state.tenant,
  loading: (state) => state.loading,
  getTenantPayload: (state) => {
    const payload = {}

    if (!state.isEditing) {
      payload.searchable = state.tenant.searchable
    }

    const integrator = {
      system: state.tenant.integrator,
      credit: null,
      coverage: null,
      bepeople: {
        query_usage: state.tenant.integrator_info_status.bepeople
      }
    }

    if (state.tenant.username) {
      integrator.username = state.tenant.username
    }
    if (state.tenant.integratorUrl) {
      integrator.url = state.tenant.integratorUrl
    }
    if (state.tenant.password) {
      integrator.password = state.tenant.password
    }

    if (state.tenant.integrator_info_status.credit) {
      integrator.credit = {}
      integrator.credit.active = state.tenant.integrator_info_status.credit
      if (state.tenant.credit_integrator) {
        integrator.credit.system = state.tenant.credit_integrator
      }
      if (state.tenant.credit_username) {
        integrator.credit.username = state.tenant.credit_username
      }
      if (state.tenant.credit_password) {
        integrator.credit.password = state.tenant.credit_password
      }

      if (state.tenant.allow_cache) {
        integrator.credit.allow_cache = state.tenant.allow_cache
        integrator.credit.cache_expiration_time = Number(state.tenant.cache_expiration_time)
      }

      if(state.tenant.score_min) {
        integrator.credit.score_min = Number(state.tenant.score_min)
      }

      if (state.tenant.score_max) {
        integrator.credit.score_max = Number(state.tenant.score_max)
      }
    }

    if (state.tenant.integrator_info_status.coverage) {
      integrator.coverage = {}
      integrator.coverage.active = state.tenant.integrator_info_status.coverage
      if (state.tenant.coverage_integrator) {
        integrator.coverage.system = state.tenant.coverage_integrator
      }
      if (state.tenant.coverage_username) {
        integrator.coverage.username = state.tenant.coverage_username
      }
      if (state.tenant.coverage_password) {
        integrator.coverage.password = state.tenant.coverage_password
      }
    }

    if (state.tenant.integrator_info_status.bepeople) {
      if (state.tenant.allow_only_qualified_legal_responsible) {
        integrator.bepeople.representative_qualification_rule = state.tenant.allow_only_qualified_legal_responsible
      }
      if (state.tenant.allow_add_legal_responsible) {
        integrator.bepeople.allow_freelance_representative = state.tenant.allow_add_legal_responsible
      }
    }

    const biometry = {
      send_link_by_whatsapp: state.tenant.sendLinkByWhatsapp,
      version: state.tenant.version,
      resend_link_interval: state.tenant.resendLinkInterval
    }

    if (state.tenant.whatsappSendOrigin) {
      biometry.whatsapp_send_origin = state.tenant.whatsappSendOrigin
    }

    return {
      name: state.tenant.name,
      url: state.tenant.URL,
      prefix: state.tenant.prefix,
      slug: state.tenant.slug,
      status: state.tenant.active,
      start_date: toApiDate(state.tenant.startDate),
      end_date: toApiDate(state.tenant.endDate),
      primary_color: state.tenant.mainColor,
      secondary_color: state.tenant.secondaryColor,
      modules: state.tenant.modules,
      profiles: state.tenant.profiles,
      integrator,
      biometry,
      due_days: state.tenant.dueDays,
      payment_types: state.tenant.paymentTypes,
      qr_code_expiration_minutes: state.tenant.qrCodeValidityTime,
      shipping_methods: state.tenant.shippingMethods,
      ...payload
    }
  },
  getPaymentTypesOptions: (state) => state.paymentTypesOptions,
  getShippingMethodsOptions: (state) => state.shippingMethodsOptions,
}
